import Vue from 'vue';
import Router from 'vue-router';
import Booking from '@/components/Booking';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'booking',
            component: Booking
        },
        {
            path: '/customer-portal',
            name: 'booking',
            component: Booking
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js